import React from 'react';
import { formatCurrency } from '../../helpers/currencies';
const AddOnButton = ({ product, customClass }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: `product-button customised-image-elem ${product.handle}` }, product.products.map((bundleProd, compIndex) => (React.createElement("div", { className: `type--${bundleProd.part}`, key: `${bundleProd.handle}-${compIndex}` },
            React.createElement("img", { src: bundleProd.selectedVariant.customiser_image }))))),
        product.price > 0 ? React.createElement("div", { className: "price-tag price-tag--active" },
            "+",
            formatCurrency(product.price)) : null));
};
export default AddOnButton;
